import { ComponentPropsWithoutRef, FC } from 'react';

type TreeIconProps = ComponentPropsWithoutRef<'svg'>;

export const TreeIcon: FC<TreeIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M11.2085 13.7918V11.5418H7.4585V3.54183H4.79183V5.79183H0.208496V0.208496H4.79183V2.4585H11.2085V0.208496H15.7918V5.79183H11.2085V3.54183H8.54183V10.4585H11.2085V8.2085H15.7918V13.7918H11.2085ZM12.2918 4.7085H14.7085V1.29183H12.2918V4.7085ZM12.2918 12.7085H14.7085V9.29183H12.2918V12.7085ZM1.29183 4.7085H3.7085V1.29183H1.29183V4.7085Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
